/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateArticleInput = {|
  categories: $ReadOnlyArray<?CategoryInput>,
  title: string,
  content: string,
  published?: ?boolean,
  file: any,
  sportId?: ?number,
  playerMentions?: ?$ReadOnlyArray<?string>,
  slateId?: ?string,
  clientMutationId?: ?string,
|};
export type CategoryInput = {|
  value: string,
  label: string,
|};
export type CreateArticleMutationVariables = {|
  input: CreateArticleInput
|};
export type CreateArticleMutationResponse = {|
  +createArticle: ?{|
    +article: ?{|
      +title: string
    |}
  |}
|};
export type CreateArticleMutation = {|
  variables: CreateArticleMutationVariables,
  response: CreateArticleMutationResponse,
|};
*/


/*
mutation CreateArticleMutation(
  $input: CreateArticleInput!
) {
  createArticle(input: $input) {
    article {
      title
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateArticleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateArticlePayload",
        "kind": "LinkedField",
        "name": "createArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleType",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateArticleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateArticlePayload",
        "kind": "LinkedField",
        "name": "createArticle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleType",
            "kind": "LinkedField",
            "name": "article",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0e10c24678d71e818c67091c5e34b76b",
    "id": null,
    "metadata": {},
    "name": "CreateArticleMutation",
    "operationKind": "mutation",
    "text": "mutation CreateArticleMutation(\n  $input: CreateArticleInput!\n) {\n  createArticle(input: $input) {\n    article {\n      title\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a2c28eccc75e7d5d29c65f6cbdc930a8';

module.exports = node;
